<div class="flex flex-col">
    <div class="flex gap-2 text-base font-medium">
        <label *ngIf="config?.label !== null" [for]="config?.id"
            >{{ config?.label }}:</label
        >
        <span>{{ value }}</span>
    </div>
    <ng-template [ngIf]="!control" [ngIfElse]="reactiveFormField">
        <input
            type="range"
            [name]="config?.name ?? ''"
            [id]="config?.id ?? ''"
            [min]="min"
            [max]="max"
            [step]="step"
            [disabled]="disabled"
            [(ngModel)]="value"
            (ngModelChange)="onChangeListener($event)"
        />
    </ng-template>
    <ng-template #reactiveFormField>
        <input
            type="range"
            [name]="config?.name ?? ''"
            [id]="config?.id ?? ''"
            [min]="min"
            [max]="max"
            [step]="step"
            [formControl]="control"
        />
    </ng-template>
</div>
